var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhrOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#2E3438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6705 3.08036H17.1136V3.05357C17.1123 2.6419 16.9323 2.24744 16.6129 1.95634C16.2936 1.66525 15.8608 1.50119 15.4091 1.5H8.59091C8.13924 1.50119 7.70644 1.66525 7.38705 1.95634C7.06767 2.24744 6.88767 2.6419 6.88636 3.05357V3.08036H4.32955C3.87787 3.08155 3.44507 3.24561 3.12569 3.5367C2.80631 3.82779 2.6263 4.22226 2.625 4.63393V20.9464C2.6263 21.3581 2.80631 21.7526 3.12569 22.0437C3.44507 22.3347 3.87787 22.4988 4.32955 22.5H10.2955C10.2955 22.5 16.875 22.5 19.6705 22.5C20.1732 22.5 20.6376 22.3922 21 22.0437C21.3395 21.7172 21.375 21.4174 21.375 20.9464C21.375 19.5 21.375 9.29464 21.375 9.29464V4.63393C21.3737 4.22226 21.1937 3.82779 20.8743 3.5367C20.5549 3.24561 20.1221 3.08155 19.6705 3.08036ZM4.32955 20.9464H10.2955H19.6705V4.63393H17.1136V6.21428H6.88636V4.63393H4.32955V20.9464ZM8.59091 4.66072H15.4091V3.05357H8.59091V4.66072Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6815 11.1438L11.0592 16.0369L8.30301 12.9732L9.69694 11.7191L11.0929 13.2708L14.3185 9.8562L15.6815 11.1438Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhrOrder);
export default __webpack_public_path__ + "static/media/ehr_order.88dc38ece0e41a7fe95c8da27aa5947c.svg";
export { ForwardRef as ReactComponent };